import { getEstablecimientoLS } from "@/shared/helpers";
import { labAs400Service } from "@/views/laboratorio/services";
import store from "@/store";



export const searchLabByName = async (search) => {


  // console.log(store.state?.atencionCita?.dataCita?.doctor)

  const especialidadesNormales = ['0000000107', '0000000531', '0000000148', '0000000582']
  const establecimiento = getEstablecimientoLS();

  const codEspecialidad = store.state?.atencionCita?.dataCita?.doctor?.especialidad?.codEsp

  const validatorEsp = especialidadesNormales.includes(codEspecialidad)
  
  const cobertura = store.state?.atencionCita?.dataCita?.cobSeleccionada?.id

  let establecimientoId = establecimiento?.id

  if (establecimientoId === '2' || establecimientoId === '5') { // valido si es kennedy o san juan
    if(!validatorEsp && cobertura === '3') { // si no esta dentro de los normales le asigno los valores de san juan
      establecimientoId = '5'
    } else if (validatorEsp && cobertura === '3'){ // si esta dentro de los normales le asigno los valores de samborondon
      establecimientoId = '1'
    }        
  }

  
  const responseSearch400 = await labAs400Service.searchLab(search, establecimientoId);

  // Filtrar duplicados por código
  const seenCodes = new Set();
  const uniqueLabs = responseSearch400.filter(result => {
    if (seenCodes.has(result.codigo)) return false;
    
    seenCodes.add(result.codigo);
    return true;
  });

  // Mapear a la estructura deseada
  const labMapped = uniqueLabs.map(result => ({
    ...result,
    value: result.id,
    text: `(${result.codigo}) ${result.descripcion}`
  }));

  return labMapped;
}